// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

// -- constants
import Constants from 'constants/Constants';

// -- entities
import OpeningHours from 'PMT/entities/OpeningHours';
import OpeningHour from 'PMT/entities/OpeningHour';

// -- views
import AbstractComponent from 'components/AbstractComponent';
import OpeningHoursForDay from './OpeningHoursForDay';
import AddOpeningHourModal from './AddOpeningHourModal';

export default class OpeningHoursForm extends AbstractComponent {

  static defaultProps = {
    readOnly: false
  };

  static propTypes = {
    openingHours: PropTypes.objectOf(OpeningHour).isRequired,

    /**
     * @param OpeningHours
     */
    onChange: PropTypes.func.isRequired,

    readOnly: PropTypes.bool
  };

  state = {
    displayAddOpeningHourModal: false,

    addOpeningHourModalDefaultDay: Constants.Day.MONDAY
  };

  // -- events opening hour
  removeOpeningHourForDay = (day: number, openingHour: OpeningHour) => {
    const openingHours:OpeningHours = this.props.openingHours;
    openingHours.removeForDay(day, openingHour);
    this.props.onChange(openingHours);
  };

  addOpeningHourForDay = (day: number, openingHour: OpeningHour) => {
    const openingHours: OpeningHours = this.props.openingHours;
    openingHours.addForDay(day, openingHour);
    this.props.onChange(openingHours);
  };

  // -- events modal
  displayAddOpeningHourModal = (defaultDay: number = Constants.Day.MONDAY) => {
    this.setState({
      displayAddOpeningHourModal: true,
      addOpeningHourModalDefaultDay: defaultDay
    });
  };

  hideAddOpeningHourModal = () => {
    this.setState({
      displayAddOpeningHourModal: false
    });
  };

  // -- renderers
  renderHeader() {
    if (this.props.readOnly) {
      return (null);
    }

    return (
      <div>
        <button
          className="btn btn-primary"
          onClick={(event) => { event.preventDefault(); this.displayAddOpeningHourModal(); }}
        >
          {I18n.tr('components.opening_hours.form.add_opening_hour')}
        </button>
      </div>
    );
  }

  renderBody() {
    const openingsHours:OpeningHours = this.props.openingHours;

    return (
      <div>
        <div className="row">
          <div className="col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block">
            <h3>
              {_.capitalize(I18n.tr('global.days.monday'))}
            </h3>

            {this.renderAddForDayBtn(Constants.Day.MONDAY)}
            <OpeningHoursForDay
              day={Constants.Day.MONDAY}
              openingsHours={openingsHours.getForDay(Constants.Day.MONDAY)}
              onDelete={this.removeOpeningHourForDay}
              readOnly={this.props.readOnly}
            />
          </div>

          <div className="col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block">
            <h3>
              {_.capitalize(I18n.tr('global.days.tuesday'))}
            </h3>

            {this.renderAddForDayBtn(Constants.Day.TUESDAY)}
            <OpeningHoursForDay
              day={Constants.Day.TUESDAY}
              openingsHours={openingsHours.getForDay(Constants.Day.TUESDAY)}
              onDelete={this.removeOpeningHourForDay}
              readOnly={this.props.readOnly}
            />
          </div>

          <div className="col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block">
            <h3>
              {_.capitalize(I18n.tr('global.days.wednesday'))}
            </h3>

            {this.renderAddForDayBtn(Constants.Day.WEDNESDAY)}
            <OpeningHoursForDay
              day={Constants.Day.WEDNESDAY}
              openingsHours={openingsHours.getForDay(Constants.Day.WEDNESDAY)}
              onDelete={this.removeOpeningHourForDay}
              readOnly={this.props.readOnly}
            />
          </div>

          <div className="col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block">
            <h3>
              {_.capitalize(I18n.tr('global.days.thursday'))}
            </h3>

            {this.renderAddForDayBtn(Constants.Day.THURSDAY)}
            <OpeningHoursForDay
              day={Constants.Day.THURSDAY}
              openingsHours={openingsHours.getForDay(Constants.Day.THURSDAY)}
              onDelete={this.removeOpeningHourForDay}
              readOnly={this.props.readOnly}
            />
          </div>

          <div className="col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block">
            <h3>
              {_.capitalize(I18n.tr('global.days.friday'))}
            </h3>

            {this.renderAddForDayBtn(Constants.Day.FRIDAY)}
            <OpeningHoursForDay
              day={Constants.Day.FRIDAY}
              openingsHours={openingsHours.getForDay(Constants.Day.FRIDAY)}
              onDelete={this.removeOpeningHourForDay}
              readOnly={this.props.readOnly}
            />
          </div>

          <div className="col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block">
            <h3>
              {_.capitalize(I18n.tr('global.days.saturday'))}
            </h3>

            {this.renderAddForDayBtn(Constants.Day.SATURDAY)}
            <OpeningHoursForDay
              day={Constants.Day.SATURDAY}
              openingsHours={openingsHours.getForDay(Constants.Day.SATURDAY)}
              onDelete={this.removeOpeningHourForDay}
              readOnly={this.props.readOnly}
            />
          </div>

          <div className="col-xs-12 col-sm-3 top-buffer-30 opening_hour_day_block">
            <h3>
              {_.capitalize(I18n.tr('global.days.sunday'))}
            </h3>

            {this.renderAddForDayBtn(Constants.Day.SUNDAY)}
            <OpeningHoursForDay
              day={Constants.Day.SUNDAY}
              openingsHours={openingsHours.getForDay(Constants.Day.SUNDAY)}
              onDelete={this.removeOpeningHourForDay}
              readOnly={this.props.readOnly}
            />
          </div>
        </div>
      </div>
    );
  }

  renderAddForDayBtn(day) {
    if (this.props.readOnly) {
      return (null);
    }
    return (
      <div
        className="pointer"
        onClick={() => this.displayAddOpeningHourModal(day) }
      >
        <i
          className="fa fa-plus"
        />
        &nbsp;
        {I18n.tr('components.opening_hours.form.add_opening_hour')}
      </div>
    );
  }

  renderAddOpeningHourModal() {
    if (!this.state.displayAddOpeningHourModal) {
      return (null);
    }

    const defaultDay = this.state.addOpeningHourModalDefaultDay;

    // Get a default opening hour suggestion based on all the others opening hours
    const defaultOpeningHour: OpeningHour = this.props.openingHours.getSuggestOpeningHourForDay(defaultDay);

    return (
      <AddOpeningHourModal
        show={this.state.displayAddOpeningHourModal}
        onHide={this.hideAddOpeningHourModal}
        onAddOpeningHourForDay={this.addOpeningHourForDay}
        defaultOpeningHour={defaultOpeningHour}
        defaultDay={defaultDay}
      />
    );
  }

  render() {
    return (
      <div className="order_settings_page">
        <div>
          {this.renderHeader()}
          {this.renderBody()}
          {this.renderAddOpeningHourModal()}
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./scripts/components/openingHours/OpeningHoursForm.js